import React, { useState } from "react";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import Calendar from "../../components/Calendar/Calendar";
import { formateDate, toaster } from "../../utils/utils";

const FilterComponent = ({
  status,
  onStatusChange,
  proposalNumber,
  onProposalNumberChange,
}) => {
  return (
    <div className="filter-component">
      <div className="filter-options" style={{ "align-items": "end" }}>
        {/* Proposal Number */}
        <div className="filter">
          <label>{`Proposal Number: `}</label>
          <input
            type="text"
            className="filter-select"
            value={proposalNumber}
            inputMode="numeric"
            placeholder="Enter 10-digit proposal no"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              onProposalNumberChange(value);
              if (value.length === 10) {
              }
            }}
          />
        </div>

        {/* Receipt Status  */}
        <div className="filter">
          <label>{`Receipt Status: `}</label>
          <select
            className="filter-select"
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}
          >
            <option value="">All</option>
            <option value="YET_TO_ACKNOWLEDGE">Yet to acknowledge</option>
            <option value="ACKNOWLEDGED">Acknowledged</option>
            <option value="CANCELLED">Cancelled</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;

export const DateFilterComponent = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  applyDateRange,
}) => {
  const [startTimestamp, setStartTimestamp] = useState(null);
  const [endTimestamp, setEndTimestamp] = useState(null);

  /* ---------- helpers ---------- */

  const normalize = (d) => {
    const date = new Date(d);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  // inclusive 30-day range
  const isRangeWithin30Days = (start, end) => {
    if (!start || !end) return false;

    const diff =
      (normalize(end) - normalize(start)) / (1000 * 60 * 60 * 24) + 1;

    return diff > 0 && diff <= 30;
  };

  const maxEndDate = startTimestamp
    ? (() => {
        const max30 = addDays(normalize(startTimestamp), 29); // inclusive
        const today = normalize(new Date());
        return max30 < today ? max30 : today;
      })()
    : null;

  /* ---------- UI ---------- */

  return (
    <div className="upfront-daterange">
      <div className="duration-sec-wrapper">
        <div className="dateRangeSec">
          {/* FROM DATE */}
          <div className="date-input-row">
          <div>From:</div>
            <div
              className="input-box"
              onClick={() => {
                setFromDate(true);
                setToDate(false);
              }}
            >
              <span className={`date-value ${startTimestamp ? "active" : ""}`}>
                {startTimestamp
                  ? formateDate(new Date(startTimestamp))
                  : "DD/MM/YYYY"}
              </span>
              <span className="calendar_icon" />
            </div>
          </div>

          {/* TO DATE */}
          <div className="date-input-row">
          <div>To:</div>
            <div
              className={`input-box ${!startTimestamp ? "disabled" : ""}`}
              onClick={() => {
                if (!startTimestamp) {
                  toaster("error", "Please select From Date first");
                  return;
                }
                setToDate(true);
                setFromDate(false);
              }}
            >
              <span className={`date-value ${endTimestamp ? "active" : ""}`}>
                {endTimestamp
                  ? formateDate(new Date(endTimestamp))
                  : "DD/MM/YYYY"}
              </span>
              <span className="calendar_icon" />
            </div>
          </div>

          {/* APPLY */}
          <div className="date-range-apply-btn">
            <button
              disabled={!isRangeWithin30Days(startTimestamp, endTimestamp)}
              className={
                !isRangeWithin30Days(startTimestamp, endTimestamp)
                  ? "disabled"
                  : ""
              }
              onClick={() => {
                if (!isRangeWithin30Days(startTimestamp, endTimestamp)) {
                  toaster("error", "Date range cannot exceed 30 days");
                  return;
                }

                applyDateRange(
                  formateDate(new Date(startTimestamp), "-"),
                  formateDate(new Date(endTimestamp), "-"),
                );
              }}
            >
              Filter
            </button>
          </div>
        </div>

        {/* FROM DATE CALENDAR */}
        {fromDate && (
          <MobilePopUp
            hideCloseBtn
            removeHeader
            cssClass="daterange-mobilepopup"
          >
            <Calendar
              dob={startTimestamp}
              maxDate={new Date()}
              onCancel={() => {
                setFromDate(false);
              }}
              onApply={(sd) => {
                setFromDate(false);
                setStartTimestamp(sd);

                // clear invalid end date
                if (endTimestamp && !isRangeWithin30Days(sd, endTimestamp)) {
                  setEndTimestamp(null);
                }
              }}
            />
          </MobilePopUp>
        )}

        {/* TO DATE CALENDAR */}
        {toDate && startTimestamp && (
          <MobilePopUp
            hideCloseBtn
            removeHeader
            cssClass="daterange-mobilepopup"
          >
            <Calendar
              dob={endTimestamp}
              minDate={normalize(startTimestamp)}
              maxDate={maxEndDate}
              onCancel={() => {
                setToDate(false);
              }}
              onApply={(sd) => {
                setToDate(false);
                setEndTimestamp(sd);
              }}
            />
          </MobilePopUp>
        )}
      </div>
    </div>
  );
};
